import { siteImages } from "./siteImages";

/** Produktions-Fallback; auf dev.* Hosts resolveBookingUrl() verwenden. */
export const BOOKING_URL = "https://booking.campingplatz-mainkur.de";
export const API_BASE = "https://api.campingplatz-mainkur.de";
export const TENANT_SLUG = "default";

export const site = {
  name: "Campingplatz Mainkur",
  address: "Frankfurter Landstraße 107, 63477 Maintal",
  phone: "+49 69 / 41 21 93",
  phoneTel: "+4969412193",
  email: "info@campingplatz-mainkur.de",
  gps: "50°08'17''N ; 8°46'55''E",
  gpsCoords: { lat: 50.138056, lng: 8.781944 },
  season: { open: "1. April", close: "30. September" },
  closed: { from: "1. Oktober", until: "31. März" },
  reception: {
    morning: "10:00 – 12:00 Uhr",
    afternoon: "15:00 – 18:00 Uhr",
  },
  pitchAvailable: "11:00 Uhr",
  departure: "11:00 Uhr",
  nightQuiet: "22:00 – 07:00 Uhr",
} as const;

export const galleryImages = [
  { src: "/images/IMG_0930.jpg", alt: "Wohnmobil am Main, im Hintergrund die Frankfurter Skyline" },
  { src: "/images/IMG_0888.jpg", alt: "Stellplätze auf der Wiese unter Bäumen" },
  { src: "/images/IMG_0920-scaled.jpg", alt: "Zelt und Wohnmobil direkt am Main" },
  { src: "/images/IMG_0928.jpg", alt: "Weg über die Wiese am Campingplatz" },
  { src: "/images/IMG_0904.jpg", alt: "Spielplatz und Tischtennis" },
  { src: "/images/IMG_0885-scaled.jpg", alt: "Sanitärgebäude auf dem Platz" },
  { src: "/images/IMG_7460-scaled.jpg", alt: "Waschtisch im sanierten Sanitärbereich" },
  { src: "/images/IMG_7442-scaled.jpg", alt: "Waschräume mit Einzelkabinen" },
  { src: "/images/IMG_4482-scaled.jpg", alt: "Waschbecken in der Sanitäranlage" },
  { src: "/images/IMG_E7445-scaled.jpg", alt: "Waschtische im Sanitärbereich" },
  { src: "/images/IMG_7450-scaled.jpg", alt: "Dusche im Sanitärbereich" },
  { src: "/images/IMG_7451-scaled.jpg", alt: "Duschkabine" },
  { src: "/images/IMG_7453-scaled.jpg", alt: "Dusche mit Sitzbank" },
  { src: "/images/IMG_4477-scaled.jpg", alt: "Spülküche" },
  { src: "/images/IMG_7620-scaled.jpg", alt: "Kiosk mit Lebensmitteln" },
  { src: "/images/IMG_0867.jpg", alt: "Getränke und Snacks im Kiosk" },
  { src: "/images/IMG_7603.jpg", alt: "Aufenthaltsraum mit Blick auf den Main" },
  { src: "/images/IMG_7618.jpg", alt: "Sitzecke im Aufenthaltsraum" },
] as const;

export interface PitchPrice {
  id: string;
  name: string;
  note: string;
  amount: number;
  image: { src: string; alt: string };
}

export interface AdditionalPrice {
  id: string;
  name: string;
  note: string;
  /** Numeric amount; null for included/fixed-text items */
  amount: number | null;
  /** Included in the night calculator */
  calculable: boolean;
  /** Multiply by person count (adults/children/dogs) */
  perPerson?: "adults" | "children" | "dogs";
  /** Display-only label when amount is null */
  displayPrice?: string;
}

export const pitchPrices: PitchPrice[] = [
  {
    id: "standard",
    name: "Stellplatz",
    note: "Ruhiger Platz auf unserem Wiesengelände",
    amount: 13.0,
    image: siteImages.pitches.standard,
  },
  {
    id: "komfort",
    name: "Komfortplatz",
    note: "Frisch- und Abwasseranschluss am Platz",
    amount: 16.5,
    image: siteImages.pitches.komfort,
  },
  {
    id: "premium",
    name: "Premiumplatz",
    note: "Frisch- und Abwasser mit Mainblick",
    amount: 19.0,
    image: siteImages.pitches.premium,
  },
];

export const pitchPricesEn: PitchPrice[] = [
  {
    id: "standard",
    name: "Standard pitch",
    note: "Quiet pitch on our meadow grounds",
    amount: 13.0,
    image: siteImages.pitches.standard,
  },
  {
    id: "komfort",
    name: "Comfort pitch",
    note: "Fresh & waste water at the pitch",
    amount: 16.5,
    image: siteImages.pitches.komfort,
  },
  {
    id: "premium",
    name: "Premium pitch",
    note: "Fresh & waste water with Main view",
    amount: 19.0,
    image: siteImages.pitches.premium,
  },
];

export const additionalPrices: AdditionalPrice[] = [
  {
    id: "adult",
    name: "Erwachsener",
    note: "ab 15 Jahren, pro Nacht",
    amount: 12.0,
    calculable: true,
    perPerson: "adults",
  },
  {
    id: "child",
    name: "Kind",
    note: "2–14 Jahre, pro Nacht",
    amount: 6.0,
    calculable: true,
    perPerson: "children",
  },
  {
    id: "dog",
    name: "Hund",
    note: "pro Nacht",
    amount: 4.0,
    calculable: true,
    perPerson: "dogs",
  },
  {
    id: "electricity",
    name: "Strom pauschal",
    note: "6 kWh / Nacht inklusive",
    amount: 4.5,
    calculable: true,
  },
  {
    id: "electricity_kwh",
    name: "1 kWh Strom",
    note: "bei Mehrverbrauch von 6 kWh / Nacht",
    amount: 0.85,
    calculable: false,
  },
  {
    id: "showers",
    name: "Duschen",
    note: "Warm- und Kaltwasser",
    amount: null,
    calculable: false,
    displayPrice: "inkl.",
  },
  {
    id: "visitor_adult",
    name: "Besucher Erwachsene",
    note: "pro Besuch",
    amount: 2.0,
    calculable: false,
  },
  {
    id: "visitor_child",
    name: "Besucher Kinder",
    note: "pro Besuch",
    amount: 1.0,
    calculable: false,
  },
];

export const additionalPricesEn: AdditionalPrice[] = [
  {
    id: "adult",
    name: "Adult",
    note: "from 15 years, per night",
    amount: 12.0,
    calculable: true,
    perPerson: "adults",
  },
  {
    id: "child",
    name: "Child",
    note: "2–14 years, per night",
    amount: 6.0,
    calculable: true,
    perPerson: "children",
  },
  {
    id: "dog",
    name: "Dog",
    note: "per night",
    amount: 4.0,
    calculable: true,
    perPerson: "dogs",
  },
  {
    id: "electricity",
    name: "Electricity flat rate",
    note: "6 kWh / night included",
    amount: 4.5,
    calculable: true,
  },
  {
    id: "electricity_kwh",
    name: "1 kWh electricity",
    note: "for consumption above 6 kWh / night",
    amount: 0.85,
    calculable: false,
  },
  {
    id: "showers",
    name: "Showers",
    note: "Hot & cold water",
    amount: null,
    calculable: false,
    displayPrice: "incl.",
  },
  {
    id: "visitor_adult",
    name: "Visitor adult",
    note: "per visit",
    amount: 2.0,
    calculable: false,
  },
  {
    id: "visitor_child",
    name: "Visitor child",
    note: "per visit",
    amount: 1.0,
    calculable: false,
  },
];
